<template>
    <detail :id="id" verify></detail>
</template>

<script>
    import detail from './user_auth_detail.vue'

    export default {
        name: 'user_auth_verify',

        components: {
            detail
        },

        props: {
            id: String
        }
    }
</script>